/**
 * PC Dice Color Schemes
 *
 * Color-specific schemes for the PC dice design.
 * Each color defines a Minecraft-font number color, a multi-stop face gradient,
 * and the two overlay gradient border colors (shared across all colors).
 *
 * Colors extracted from Figma SVG exports:
 *   Blue:   Dice_PC_B_*.svg
 *   Red:    Dice_PC_R_*.svg
 *   Green:  Dice_PC_G_*.svg
 *   Yellow: Dice_PC_Y_*.svg
 */

export interface PcDiceColorScheme {
  /** Unique name used as gradient ID prefix to avoid SVG id collisions */
  name: string;
  /** Fill color for the Minecraft-font number */
  numberColor: string;
  /** 6-stop gradient stops for the main die face (left-to-right) */
  faceGradient: [string, string, string, string, string, string];
  /**
   * Middle transparent color used in the two border-edge overlay gradients.
   * The stop-opacity=0 value is always paired with this color.
   */
  overlayMidColor: string;
}

export const PC_DICE_COLOR_SCHEMES: Record<string, PcDiceColorScheme> = {
  blue: {
    name: 'blue',
    numberColor: '#2020a0',
    faceGradient: ['#576bff', '#5468fb', '#4e62f2', '#4356e1', '#3446ca', '#2334af'],
    overlayMidColor: '#3a4baf'
  },
  red: {
    name: 'red',
    numberColor: '#a02020',
    faceGradient: ['#ff5a5a', '#fb5757', '#f25151', '#e14646', '#ca3636', '#ad2323'],
    overlayMidColor: '#af3a3a'
  },
  green: {
    name: 'green',
    numberColor: '#1ea488',
    faceGradient: ['#52ffbd', '#4ffbb9', '#49f2b0', '#3ee19f', '#2fca88', '#22b573'],
    overlayMidColor: '#39b54a'
  },
  yellow: {
    name: 'yellow',
    numberColor: '#a39c1f',
    faceGradient: ['#fbff55', '#f7fb52', '#eef24c', '#dde141', '#c7ca32', '#afb222'],
    overlayMidColor: '#a1b239'
  }
};
